<template>
  <div class="c-d-flex ui-flex-col ui-flex-1">
    <div class="c-row c-horizontal-center">
      <div class="c-col-2 sm:c-col-6 md:c-col-12 lg:c-col-10 c-d-flex">
        <div class="c-d-flex ui-w-full ui-mb-4 ui-flex-col ui-mt-4">
          <div class="c-d-flex ui-flex-1 c-text-h3">
            <span>
              Selecione a área do Estratégia que corresponde à sua preparação
            </span>
          </div>
          <div
            class="c-text-b2 c-text-gray ui-mb-4"
          >
            Acesse conteúdos, ferramentas e questões organizadas para o seu estudo.
          </div>
        </div>
      </div>
    </div>

    <div class="c-row c-horizontal-center">
      <div class="c-col-2 sm:c-col-6 md:c-col-12 lg:c-col-10 c-d-flex">
        <div class="ui-flex ui-flex-col ui-w-full ui-gap-4 ui-mb-8">
          <div
            v-for="vertical in verticals"
            :key="vertical.id"
            class="vertical-card ui-flex ui-bg-white ui-rounded-lg ui-overflow-hidden ui-shadow-md ui-cursor-pointer"
            :style="{ '--hover-color': vertical.color }"
            @click="accessVertical(vertical)"
          >
            <div
              class="icon-box ui-flex ui-items-center ui-justify-center ui-w-16 sm:ui-w-24 ui-flex-shrink-0"
              :style="{ backgroundColor: vertical.color + '1A' }"
            >
              <p-owl-icon :color="vertical.color" />
            </div>
            <div class="ui-flex ui-flex-col sm:ui-flex-row ui-flex-1 ui-items-start sm:ui-items-center ui-py-4">
              <div class="ui-flex ui-flex-col ui-flex-1 ui-px-4 sm:ui-px-6">
                <span
                  style="font-weight: 700; font-size: 18px;"
                  v-html="vertical.title"
                />
                <span class="c-text-b2 c-text-gray">
                  {{ vertical.description }}
                </span>
              </div>
              <div class="ui-px-4 sm:ui-px-6 ui-mt-4 sm:ui-mt-0 ui-w-full sm:ui-w-auto">
                <c-button
                  class="ui-w-full sm:ui-w-auto"
                  size="lg"
                >
                  Acessar
                </c-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/services/token';
import { CButton } from '@estrategiahq/coruja-web-ui/dist/coruja-web-ui.cjs';
import POwlIcon from '@/components/p-owl-icon/index.vue';

export default {
  name: 'AreaDoAlunoPage',
  components: {
    CButton,
    POwlIcon,
  },
  props: {},
  data() {
    return {
    };
  },
  computed: {
    verticals() {
      return this.$vertical.getEnabled();
    },
  },
  methods: {
    accessVertical(vertical) {
      const url = typeof vertical.url === 'function'
        ? vertical.url({ token: getToken() })
        : vertical.url;
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-card {
  min-height: 88px;
  box-sizing: border-box;
  border: 1px solid #CCC;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: var(--hover-color);
  }
}
</style>
